// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"8e170e9a","224":"7172f82c","252":"5e35594e","669":"7bba0bdb","905":"788071fa","937":"5e36d6a3"}[chunkId] + ".chunk.css";
};